export interface IListResults<T> {
  count: number;
  last_evaluated_key: string | null;
  warnings: string[];
  results: T[];
}
